import { Component, ElementRef, ViewChild, AfterViewInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { IFieldModel } from '../../../../../../models/blueprint/blueprint-field.model';
import { IBluePrintModel } from '../../../../../../models/blueprint/blueprint.model';
import { DashboardHelper } from '../../../../../../services/dashboard.service';
import { Helper } from '../../../../../../services/helper.service';
import { FieldDateTimeModel, IFieldDateTimeModel } from '../../../../../../models/blueprint/blueprint-field-datetime.model';
import { UiStateStore } from '../../../../../../services/stores/ui-state.store';
import { PatchFieldPayload } from '../../../../../../models/field/patch-field-payload.model';
import { ActivatedRoute, Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { BluePrintAPIService } from '../../../../../../services/api/blueprint.api.service';
import { BlueprintDataHelper } from '../../../../../../services/helpers/blueprint-data.helper';
import { BlueprintStore } from '../../../../../../services/stores/blueprint.store';
import { UserService } from '../../../../../../services/user.service';
import { PermissionService } from '../../../../../../services/permission.service';

@Component({
  selector: 'app-blueprint-field-datetime',
  templateUrl: './blueprint-field-datetime.component.html',
  styleUrls: ['./blueprint-field-datetime.component.css'],
  standalone: false,
})
export class BlueprintFieldDatetimeComponent implements AfterViewInit, OnDestroy {
  selectedBluePrintField: IFieldModel = {} as IFieldModel;
  selectedBluePrintFieldOldVal: IFieldModel = {} as IFieldModel;
  datetimeField: IFieldDateTimeModel = {} as IFieldDateTimeModel;
  tempDate: Date | null = null;
  selectedBluePrint: IBluePrintModel = {} as IBluePrintModel;
  oldName: string = '';
  public subscribers: any = {};
  @ViewChild('inputName') inputNameElement!: ElementRef;
  @ViewChild('myForm') myForm!: NgForm;
  @ViewChild('datetimeFieldInput') datetimeFieldInput!: any;

  constructor(
    private dashboardHelper: DashboardHelper,
    private bluePrintService: BluePrintAPIService,
    private bluePrintStore: BlueprintStore,
    private helperService: Helper,
    private uiStateStore: UiStateStore,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private bluePrintHelper: BlueprintDataHelper,
    private userService: UserService,
    private permissionService: PermissionService,
  ) {
  }

  public get isReadOnly(): boolean {
    if (this.permissionService.isSysAdmin) {
      return false;
    }
    const blueprintOrgId = this.selectedBluePrint?.organizationId?.toLowerCase();
    const userOrgId = this.userService.user?.organizationId?.toLowerCase();
    if (!blueprintOrgId || !userOrgId) {
      // Unknown org on either side - fail closed (read-only) rather than treat two empty/missing
      // org ids as a match.
      return true;
    }
    return blueprintOrgId !== userOrgId;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.subscribers.bp = this.bluePrintStore.$selectedBluePrint.subscribe((bp) => {
        if (bp) {
          this.selectedBluePrint = bp;
          if (!this.bluePrintStore.selectedBluePrintField) {
            this.subscribers.params = this.route.params.subscribe((params) => {
              if (params['id']) {
                if (this.selectedBluePrint) {
                  const blueprintField = this.selectedBluePrint.fields.find((field) => field.id === params['id']);
                  if (blueprintField) this.bluePrintStore.selectedBluePrintField = blueprintField;
                  this.dashboardHelper.setShowRightPanel(true);
                }
              }
            });
          }
        }
      });

      this.subscribers.rightPanelVisible = this.dashboardHelper.$showRightPanel.subscribe((panelVisibility) => {
        if (panelVisibility === false) {
          // If right side panel is closed without saving then reset to previous value
          if (this.selectedBluePrint && this.selectedBluePrintFieldOldVal) {
            const oldField = this.selectedBluePrint.fields.find((f) => f.id === this.selectedBluePrintFieldOldVal.id);
            if (oldField) if (oldField) this.selectedBluePrint.fields[this.selectedBluePrint.fields.indexOf(oldField)] = this.selectedBluePrintFieldOldVal;
            if (this.myForm && this.myForm.form.dirty && this.myForm.form.valid) {
              this.myForm.form.markAsPristine();
              this.cdr.detectChanges();
            }
          }
        }
      });

      this.subscribers.selectedItemChanged = this.dashboardHelper.selectedItem.subscribe((result) => {
        if (this.selectedBluePrintField && this.selectedBluePrintField.id !== result) {
          if (this.myForm && this.myForm.form.dirty && this.myForm.form.valid) {
            this.myForm.form.markAsPristine();
            this.saveWork(false);
          }
        }
      });

      this.subscribers.bpfield = this.bluePrintStore.$selectedBluePrintField.subscribe((result) => {
        if (result) this.selectedBluePrintField = result;
        this.selectedBluePrintFieldOldVal = this.helperService.getDeepCopy(result);
        if (this.selectedBluePrintField) {
          if (!this.selectedBluePrintField.value || typeof this.selectedBluePrintField.value === 'string') {
            this.datetimeField = new FieldDateTimeModel(false, false, null);
            this.selectedBluePrintField.value = this.datetimeField;
          } else {
            this.datetimeField = <IFieldDateTimeModel>this.selectedBluePrintField.value;

            // CRITICAL FIX: Convert date string to Date object if needed
            if (this.datetimeField.value && !(this.datetimeField.value instanceof Date)) {
              this.datetimeField.value = new Date(this.datetimeField.value);
            }
          }
          this.tempDate = this.datetimeField.value instanceof Date ? new Date(this.datetimeField.value) : null;
          this.oldName = this.selectedBluePrintField.name;
          this.cdr.detectChanges();
        }
      });
    });
  }

  ngOnDestroy(): void {
    this.cdr.detach();

    if (this.subscribers) {
      if (this.subscribers.bpfield) {
        this.subscribers.bpfield.unsubscribe();
      }
      if (this.subscribers.bp) {
        this.subscribers.bp.unsubscribe();
      }
      if (this.subscribers.params) {
        this.subscribers.params.unsubscribe();
      }
      if (this.subscribers.rightPanelVisible) {
        this.subscribers.rightPanelVisible.unsubscribe();
      }
      if (this.subscribers.selectedItemChanged) {
        this.subscribers.selectedItemChanged.unsubscribe();
      }
    }
  }

  public onCalendarDateChange(event: Date | null): void {
    if (this.isReadOnly) {
      return;
    }
    if (!event) return;

    // Update the temp value
    this.tempDate = event;

    // Mark form as dirty to enable save button
    if (this.myForm) {
      this.myForm.form.markAsDirty();
    }
  }

  public onSetDate(): void {
    if (this.isReadOnly) {
      return;
    }
    // Apply the temp date to the actual field
    if (this.tempDate) {
      this.datetimeField.value = this.tempDate;
    }
    this.selectedBluePrintField.value = this.datetimeField;

    // Close the overlay
    if (this.datetimeFieldInput) {
      if (typeof this.datetimeFieldInput.hide === 'function') {
        this.datetimeFieldInput.hide();
      } else {
        console.warn('datetimeFieldInput.hide is not a function');
        this.datetimeFieldInput.overlayVisible = false;
      }
    }

    // Mark as dirty and save
    if (this.myForm) {
      this.myForm.form.markAsDirty();
    }

    this.saveWork();
  }

  public onClearDate(): void {
    if (this.isReadOnly) {
      return;
    }
    this.tempDate = null;
    this.datetimeField.value = null;
    this.selectedBluePrintField.value = this.datetimeField;

    // Mark form as dirty
    if (this.myForm) {
      this.myForm.form.markAsDirty();
    }

    // Close the overlay after clearing
    if (this.datetimeFieldInput) {
      if (typeof this.datetimeFieldInput.hide === 'function') {
        this.datetimeFieldInput.hide();
      } else {
        this.datetimeFieldInput.overlayVisible = false;
      }
    }

    this.saveWork();
  }

  public selectName() {
    const value = this.inputNameElement?.nativeElement?.value?.toLowerCase() ?? '';

    if (value.startsWith('datetime')) {
      this.inputNameElement.nativeElement.select();
    }
  }

  public saveWork(updateResponse: boolean = true) {
    if (this.isReadOnly) {
      return;
    }
    this.bluePrintHelper.validateName(this.oldName, 'field');
    const patchPayload: PatchFieldPayload = new PatchFieldPayload();
    patchPayload.bluePrintId = this.selectedBluePrint.id;
    patchPayload.field = this.selectedBluePrintField;
    patchPayload.updateResponse = updateResponse;
    this.selectedBluePrintFieldOldVal = this.selectedBluePrintField;
    // Dispatching the save clears dirty: the deselect auto-save (selectedItem subscription)
    // fires on a dirty form and would otherwise re-send this same patch, writing a second
    // identical 'blueprint modified' activity log entry (ZOO-10065).
    this.myForm?.form.markAsPristine();
    this.uiStateStore.startBackendAction('Saving DateTime...');
    this.bluePrintService.patchField(patchPayload).subscribe({
      next: (result) => {
        this.uiStateStore.endBackendAction('DateTime saved!');

        // CRITICAL FIX: Ensure the date remains a Date object after save
        if (this.datetimeField.value && !(this.datetimeField.value instanceof Date)) {
          this.datetimeField.value = new Date(this.datetimeField.value);
        }

        if (this.myForm) {
          this.myForm.form.markAsPristine();
        }

        this.cdr.detectChanges();
      },
      error: (error) => {
        this.uiStateStore.endBackendAction('Error saving DateTime');
        this.myForm?.form.markAsDirty(); // save failed - keep the edit re-savable
        this.cdr.detectChanges();
      },
    });
  }

  public onNameBlur() {
    if (this.isReadOnly) {
      return;
    }
    if (this.selectedBluePrintField.name === '') {
      this.selectedBluePrintField.name = this.oldName; // revert to old name
      this.dashboardHelper.setModifiedPropertyItem({
        id: this.selectedBluePrintField.id,
        name: this.selectedBluePrintField.name,
      });
    } else {
      this.bluePrintHelper.validateName(this.oldName, 'field');
      this.oldName = this.selectedBluePrintField.name;
    }
  }

  public onChange() {
    if (this.isReadOnly) {
      return;
    }
    if (this.selectedBluePrintField.name === '') {
      return;
    }
    this.dashboardHelper.setModifiedPropertyItem({
      id: this.selectedBluePrintField.id,
      name: this.selectedBluePrintField.name,
    });
  }
}
